import { gql } from 'apollo-angular'

export const GET_INVOICES = gql`
  query ListInvoices {
    Invoices {
      docs {
        id
        amount
        paidToDate
        paymentTerm
        invoiceNumber
        invoicedAt
        url
      }
    }
  }
`
